import AddonBeforeAfter from './AddonBeforeAfter';

export default AddonBeforeAfter;
